// https://nuxt.com/docs/guide/directory-structure/plugins
export default defineNuxtPlugin((nuxtApp) => {
  // const foo = useFoo()
  console.log('Added plugin')
})
